<template>
  <Card rounded class="overflow-hidden border-slate-300 border-r-0" no-space>
    <Flex justify-between items-center class="h-8 border-b border-slate-300">
      <IconInput icon="fa-chevron-left" class="border-r border-slate-300" @click="prevMonth()" />
      <span v-html="monthName" />
      <IconInput icon="fa-chevron-right" class="border-x border-slate-300" @click="nextMonth()" />
    </Flex>
    <div class="grid grid-cols-7 text-xs border-r divide-x border-slate-300 py-[5px] bg-slate-50">
      <div class="text-center font-bold">DOM</div>
      <div class="text-center font-bold">SEG</div>
      <div class="text-center font-bold">TER</div>
      <div class="text-center font-bold">QUA</div>
      <div class="text-center font-bold">QUI</div>
      <div class="text-center font-bold">SEX</div>
      <div class="text-center font-bold">SAB</div>
    </div>
    <div class="grid grid-cols-7 text-xs">
      <Flex
        center
        v-for="(day, i) in calendar"
        :key="i"
        class="h-8 cursor-pointer border-t border-r border-slate-300"
        :class="[hoverClasses, contextualClasses(day)]"
        @click="selectDate(day)">
        {{ day.getDate() }}
      </Flex>
    </div>
  </Card>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useCalendar } from '@/composables/useCalendar'

const props = defineProps({
  modelValue: [String, Array], // Armazena a data selecionada
  range: Boolean,
})

const emits = defineEmits(['update:modelValue'])
const { calendar, targetDate, mountMonth, prevMonth, nextMonth } = useCalendar()

// Inicializa o mês atual
const date = new Date()
mountMonth(date)

const rangedDate = ref(props.modelValue ?? [])
const hoverClasses = ['hover:bg-primary-500', 'hover:border-primary-500', 'hover:text-white']

const selectDate = (day) => {
  if (props.range) {
    if (rangedDate.value.length < 2) {
      rangedDate.value.push(day.toISOString())
    } else {
      rangedDate.value = []
      rangedDate.value.push(day.toISOString())
    }
    emits('update:modelValue', rangedDate.value)
  } else {
    const formattedDate = day.toISOString()
    emits('update:modelValue', formattedDate)
  }
}

const inDateRange = (rawDay) => {
  const day = rawDay.toISOString()
  if (!props.range) {
    return false
  }

  if (day >= rangedDate.value[0] && day <= rangedDate.value[1]) {
    return true
  } else if (rangedDate.value[0] && day === rangedDate.value[0].split(' ')[0]) {
    return true
  }

  return false
}

// Aplica classe para a data selecionada
const contextualClasses = (day) => {
  const today = new Date()
  const todayStr = today.toISOString().substring(0, 10) // "YYYY-MM-DD"
  const dayStr = day.toISOString().substring(0, 10) // "YYYY-MM-DD"
  const isToday = dayStr === todayStr

  const isSelected =
    (props.modelValue && props.modelValue[0] === day.toISOString()) ||
    (props.modelValue && props.modelValue.length > 1 && props.modelValue[1] === day.toISOString())
  const isOutsideMonth = day.getMonth() !== targetDate.value.getMonth()

  if (isSelected) {
    return 'bg-primary-500 text-white' // Data selecionada
  }
  if (isToday) {
    return 'bg-primary-300 text-white' // Dia de hoje
  }
  if (isOutsideMonth) {
    return 'bg-gray-200 text-gray-500' // Fora do mês atual
  }

  if (inDateRange(day)) {
    return 'bg-primary-100 text-primary-500' // Fora do mês atual
  }
  return ''
}

// Nome do mês no cabeçalho
const monthName = computed(() => {
  if (!targetDate.value) return ''
  const month = targetDate.value.toLocaleString('default', { month: 'long' })
  const year = targetDate.value.toLocaleString('default', { year: 'numeric' })
  return `<span class="capitalize">${month}</span> de ${year}`
})
</script>
